export const domain = "courses.ieuukraine.com";
export const serverBaseUrl = `https://${domain}/api/v1`;
export const serverName = `https://${domain}/api`;
export const webSocketUrl = `wss://${domain}/api/v1/chat`;
export const docParserBaseUrl = `https://${domain}/docs-parser`;
